import React, { useState } from "react";

const AboutUsSection = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="px-4 md:px-24">
      <div className="flex flex-row md:mt-14 mt-5 md:gap-24 gap-4 items-start">
        {/* Left Side - Image always visible */}
        <div className="relative w-[160px] md:w-[400px] mb-8 md:mb-0 group">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745788274/image_58_p4r6df.png"
            alt="Main"
            className="rounded-lg w-[150px] md:w-full h-auto transition-transform duration-300 group-hover:scale-105"
          />
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745788274/image_59_jovrou.png"
            alt="Small"
            className="absolute bottom-[-10px] md:bottom-[-55px] left-[75%] md:left-[85%] transform -translate-x-1/2 w-[70px] md:w-[221px] h-[90px] md:h-[300px] rounded-md shadow-lg transition-transform duration-300 group-hover:scale-110"
          />
          {/* Box at bottom */}
          <div className="absolute bottom-[-10px] md:bottom-[-50px] left-2 md:left-10 w-[60px] md:w-[160px]">
            <div className="bg-[#F38323] text-white text-[8px] md:text-[32px] font-bold py-2 md:py-2.5 text-center rounded-t-md md:pr-3 transition-transform duration-300 hover:-translate-y-2">
              +100K
            </div>
            <div className="bg-[#E27B24] text-white text-[6px] md:text-[20px] py-1.5 md:py-2 md:px-4 px-2 rounded-b-md leading-tight">
              Entrepreneurs <br /> Trust us
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="flex-1">
          {/* About Us heading */}
          <div className="flex justify-between">
            <h2 className="text-[#03897B] text-[10px] md:text-[36px] font-bold mb-2 transition-transform duration-300 hover:-translate-y-1 hover:text-[#02645d]">
              About Us
            </h2>
            <div>
              <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[14px] text-[6px] bg-[#03897B] text-white px-2 md:px-4 w-[70px] md:w-[200px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-medium md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
                  ABOUT US
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[39px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#F38323] px-2 md:py-2 transition-transform duration-300 hover:rotate-45"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
            </div>
          </div>

          {/* Main heading */}
          <h1 className="text-black text-[8px] md:text-[36px] font-bold mb-2 leading-tight transition-opacity duration-500 hover:opacity-80">
            We are committed to empowering Entrepreneurs and building sustainable enterprises
          </h1>

          {/* Paragraph */}
          <div className="flex items-start gap-2">
            <p className="text-black text-[6px] md:text-[24px] font-normal transition-transform duration-300 hover:-translate-y-1">
              We specialise in training and development programmes that support small businesses and cooperatives......
            </p>
            <button onClick={() => setShowMore(!showMore)}>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789178/Expand_right_9_yfwyj0.png"
                alt="Expand"
                className="md:mt-10 md:w-[80px] md:h-[50px] transition-transform duration-300 hover:rotate-12"
              />
            </button>
          </div>

          {/* Additional Paragraph with animation */}
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore ? "max-h-[500px] opacity-100 mt-4" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-black text-[6px] md:text-[20px]">
              Ad-Luck is a South African consultancy and advisory firm committed to empowering entrepreneurs and building sustainable enterprises.
              We specialise in training and development programmes that support small businesses and cooperatives across high-impact sectors including Agriculture, Renewable Energy, and Waste Management. 
              Through our hands-on approach, sector expertise, and strategic partnerships, we help entrepreneurs unlock opportunities, access resources, and grow resilient, future-fit businesses that contribute meaningfully to South Africa’s economy and green transition.
            </p>
          </div>

          {/* Orange line box with text */}
          <div className="flex items-center gap-3 md:gap-4 md:mb-0 mb-2">
            <div className="h-[40px] md:h-[130px] w-[4px] md:w-2 bg-[#F38323] rounded-[5px] transition-all duration-300 hover:bg-[#e26b00]" />
            <div>
              <p className="text-black text-[6px] md:text-[24px] font-bold transition-transform duration-300 hover:-translate-y-1">
                "The more you learn, the more you earn."
              </p>
              <p className="text-black text-[6px] md:text-[24px] font-normal pl-2">
                Warren Buffett.
              </p>
            </div>
          </div>

          {/* Calendar icon with text */}
          <div className="flex items-center gap-3 md:gap-4 md:-ml-2">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745788565/Date_range_duotone_1_qet5b5.png"
              alt="Calendar"
              className="w-[20px] h-[25px] md:w-[68px] md:h-[75px] transition-transform duration-300 hover:scale-110"
            />
            <div>
              <p className="text-black text-[6px] md:text-[24px] font-bold">
                15 Years of experience
              </p>
              <p className="text-black text-[6px] md:text-[24px] font-normal">
                Panafric experience cutting across different sectors
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsSection;
